<template>
  <v-card>
    <v-toolbar flat dense v-if="showLogin">
      <v-spacer></v-spacer>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            large
            v-on="on"
            @click="loginToOrganization"
            :loading="loading"
          >
            <v-icon color="blue-gray" v-if="organization.adminUser.IsActivated"
              >mdi-account-key</v-icon
            >
          </v-btn>
        </template>
        <span
          >{{ $t("SignIn") }} - {{ organization.adminUser.Login }} ({{
            organization.adminUser.Name
          }}, {{ organization.adminUser.Surname }})
        </span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            large
            v-on="on"
            @click="activateAdmin"
            :loading="loading"
            v-if="!organization.adminUser.IsActivated"
          >
            <v-icon color="red">mdi-account</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("Administrator") + " " + $t("Blocked") }}</span>
        - <span>{{ $t("Activate") }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon large @click="edit" v-on="on">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("Edit") }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon large @click="remove" v-on="on">
            <v-icon color="red">mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("Delete") }}</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <div class="layout ma-0 align-center column">
        <img
          v-bind:src="logo"
          v-bind:alt="organization.name"
          style="max-width: 160px; max-height: 60px"
        />
        <div class="flex text-sm-center">
          <div class="subheading">{{ organization.name }}</div>
        </div>
      </div>

      <v-data-table
        :hide-default-header="true"
        :hide-default-footer="true"
        :items="dashboardItems"
        class="elevation-0 table-striped"
      >
        <template v-slot:item="props">
          <tr>
            <td class="text-xs-left">
              <v-icon>{{ props.item.icon }}</v-icon>
              <span v-t="props.item.text"></span>
            </td>
            <td class="text-xs-right">
              <v-progress-linear
                v-if="props.item.progress"
                :value="props.item.pvalue"
                :height="6"
                :color="props.item.color"
              ></v-progress-linear>
              <span v-if="props.item.progress" class="caption">{{
                props.item.value
              }}</span>
              <v-chip
                v-if="!props.item.progress"
                :color="props.item.color"
                text-color="white"
                >{{ props.item.value }}</v-chip
              >
            </td>
          </tr>
        </template>
        <template v-slot:no-data>No data</template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import UserService from "@/services/UserService";
import Utils from "@/ecm/common/Utils";

export default {
  props: {
    organization: {
      type: Object,
    },
  },
  data() {
    return {
      fab: false,
      loading: false,
      showLogin: this.$store.getters["account/currentRole"] == 0,
      dashboardItems: [
        {
          icon: "mdi-file-document",
          text: "Documents",
          value: this.organization.totalDocuments,
          color: "primary",
          progress: false,
        },
        {
          icon: "mdi-clipboard-check",
          text: "SignedDocuments",
          value: this.organization.totalSignedDocuments,
          color: "primary",
          progress: false,
        },
        {
          icon: "mdi-ballot",
          text: "ContentTypes",
          value: this.organization.totalContentTypes,
          color: "primary",
          progress: false,
        },
        {
          icon: "mdi-account-multiple",
          text: "Users",
          value: this.organization.totalUsers,
          color: "primary",
          progress: false,
        },
        {
          icon: "mdi-account-multiple",
          text: "FullAccessUsers",
          value:
            this.organization.totalFullUsers +
            "/" +
            this.organization.maxFullUsers,
          pvalue:
            (this.organization.totalFullUsers * 100) /
            this.organization.maxFullUsers,
          color:
            this.organization.maxFullUsers == 0
              ? "grey lighten-1"
              : (this.organization.totalFullUsers * 100) /
                  this.organization.maxFullUsers ==
                100
              ? "red"
              : (this.organization.totalFullUsers * 100) /
                  this.organization.maxFullUsers >=
                50
              ? "orange"
              : "green",
          progress: true,
        },
        {
          icon: "mdi-account-multiple",
          text: "ReadonlyUsers",
          value:
            this.organization.totalReadonlyUsers +
            "/" +
            this.organization.maxReadonlyUsers,
          pvalue:
            (this.organization.totalReadonlyUsers * 100) /
            this.organization.maxReadonlyUsers,
          color:
            this.organization.maxReadonlyUsers == 0
              ? "grey lighten-1"
              : (this.organization.totalReadonlyUsers * 100) /
                  this.organization.maxReadonlyUsers ==
                100
              ? "red"
              : (this.organization.totalReadonlyUsers * 100) /
                  this.organization.maxReadonlyUsers >=
                50
              ? "orange"
              : "green",
          progress: true,
        },
        {
          icon: "mdi-account-multiple",
          text: "ConcurrentUsers",
          value:
            this.organization.totalConcurrentUsers +
            "/" +
            this.organization.maxConcurrentUsers,
          pvalue:
            (this.organization.totalConcurrentUsers * 100) /
            this.organization.maxConcurrentUsers,
          color:
            this.organization.maxConcurrentUsers == 0
              ? "grey lighten-1"
              : (this.organization.totalConcurrentUsers * 100) /
                  this.organization.maxConcurrentUsers ==
                100
              ? "red"
              : (this.organization.totalConcurrentUsers * 100) /
                  this.organization.maxConcurrentUsers >=
                50
              ? "orange"
              : "green",
          progress: true,
        },
        {
          icon: "mdi-cellphone-lock",
          text: "TwoFactorAuthenticationUsers",
          value:
            this.organization.total2FAUsers +
            "/" +
            this.organization.max2FAUsers,
          pvalue:
            (this.organization.total2FAUsers * 100) /
            this.organization.max2FAUsers,
          color:
            this.organization.max2FAUsers == 0
              ? "grey lighten-1"
              : (this.organization.total2FAUsers * 100) /
                  this.organization.max2FAUsers ==
                100
              ? "red"
              : (this.organization.total2FAUsers * 100) /
                  this.organization.max2FAUsers >=
                50
              ? "orange"
              : "green",
          progress: true,
        },
        {
          icon: "mdi-cellphone-android",
          text: "RegisteredDevices",
          value:
            this.organization.totalDevices + "/" + this.organization.maxDevices,
          pvalue:
            (this.organization.totalDevices * 100) /
            this.organization.maxDevices,
          color:
            this.organization.maxDevices == 0
              ? "grey lighten-1"
              : (this.organization.totalDevices * 100) /
                  this.organization.maxDevices ==
                100
              ? "red"
              : (this.organization.totalDevices * 100) /
                  this.organization.maxDevices >=
                50
              ? "orange"
              : "green",
          progress: true,
        },
        {
          icon: "mdi-nas",
          text: "StorageUse",
          value:
            this.organization.totalUsedSpaceDisplay +
            "/" +
            this.organization.maxUsedSpaceDisplay,
          pvalue:
            (this.organization.totalUsedSpace * 100) /
            this.organization.maxUsedSpace,
          color:
            this.organization.maxUsedSpace == 0
              ? "grey lighten-1"
              : (this.organization.totalUsedSpace * 100) /
                  this.organization.maxUsedSpace ==
                100
              ? "red"
              : (this.organization.totalUsedSpace * 100) /
                  this.organization.maxUsedSpace >=
                50
              ? "orange"
              : "green",
          progress: true,
        },
      ],
    };
  },
  methods: {
    activateAdmin() {
      UserService.activate(this.organization.adminUser.Id).then((result) => {
        Utils.toast.success(
          this.$t("Administrator") + " " + this.$t("ActivatedSuccessfully")
        );
        this.organization.adminUser.IsActivated = true;
      });
    },
    loginToOrganization(e) {
      if (e) {
        e.preventDefault();
      }
      this.loading = true;
      this.$store
        .dispatch("account/login", {
          username: this.$store.getters["account/user"].Login,
          password: this.$store.getters["account/user"].Password,
          organization_id: this.organization.id,
        })
        .then((resp) => {
          this.loading = false;
          window.getApp.$emit("APP_LOGIN_SUCCESS");
          this.$router.push("/");
          this.$nextTick(function () {
            location.reload();
          });
        })
        .catch((err) => {
          window.getApp.$emit(
            "APP_MESSAGE",
            err.response != null ? err.response.data.error_description : "Error"
          );
          this.loading = false;
        });
    },
    edit() {
      this.$emit("on-edit", this.organization.id);
    },
    remove() {
      this.$emit("on-remove", this.organization.id);
    },
  },
  computed: {
    logo() {
      return `${this.$store.getters["account/apiUrl"]}/api/organization/logo/${this.organization.id}?access_token=${this.$store.getters["account/token"]}`;
    },
  },
};
</script>
